/**
 * The free-text note the carrier's driver sees for this location.
 *
 * Optional, but not always harmless — some accessorials have to be booked
 * rather than described here, so the validator can reject a note that is
 * asking for one.
 */

import NotesQuestionBubble from "@/Shared/Locations/Bubbles/NotesQuestionBubble";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { TextInput } from "@freightsimple/ui-core/Controls/TextInput";
import BookShipmentSmallSection from "../BookShipmentSmallSection";

interface BookShipmentAddressNotesSectionProps {
  index: number;
  displayName: string;
  notes: string | undefined;
  onNotesChange: (notes: string) => void;
  errorMessage: ErrorMessageType;
  forceValidation: boolean;
}

export function BookShipmentAddressNotesSection(
  props: BookShipmentAddressNotesSectionProps,
) {
  return (
    <BookShipmentSmallSection
      header={
        <>
          Notes
          <span className="ml-2 text-sm font-normal text-content-muted">
            Optional
          </span>
          <NotesQuestionBubble displayName={props.displayName} />
        </>
      }
      description="Enter any extra information you want the carrier to know about this location"
      index={props.index}
    >
      <Panel collapseOnNarrow>
        <ShowFormErrors show={props.forceValidation}>
          <FormItem label="Enter notes" error={props.errorMessage} fillWidth>
            <TextInput
              placeholder="eg. Blue dock door, or ring bell"
              width="full"
              value={props.notes}
              onChange={(e) => props.onNotesChange(e.target.value)}
              data-testid="location-notes-input"
            />
          </FormItem>
        </ShowFormErrors>
      </Panel>
    </BookShipmentSmallSection>
  );
}
